/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */
import { Noise3D } from './InteractiveComponents';
export const metadata = {
  demo: Noise3D,
  title: 'Noise (3D)'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The nice thing about noise is that you can add an extra dimension to create smooth perturbations.`}</p>
    <p>{`Try changing the `}<inlineCode parentName="p">{`Time`}</inlineCode>{` slider here:`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
